/**
 * 三包管理--》异常登记
*/
export default {
  // 登记人可编辑
  catch_edit_createby_editable: ['90100','93585'], // 202601311334204005143 
}
